import {useTranslation} from 'react-i18next'
import {matchPath, useLocation} from 'react-router-dom'
import {LoadingCircle, NonAuthLogo} from '@components/lib'

import {useProfile, useLogout} from 'hooks'
import routes from 'routes'
import {localizeRoutePath} from 'i18n/utils'

import LanguagesDropdown from '../LanguagesDropdown'

import {
  NavItemsWrapper,
  Wrapper,
  Container,
  RightButton,
  LogoLink,
  Logospan,
} from './NonAuthNavigation.styles'

const NonAuthNavigation = ({...rest}) => {
  const {t} = useTranslation()
  const location = useLocation()
  const {profile, isLoadingProfile} = useProfile()
  const logout = useLogout()

  const registerMatch = matchPath(
    {
      path: localizeRoutePath(routes.register.path),
      exact: false,
    },
    location.pathname,
  )

  return (
    <Wrapper {...rest}>
      <Container>
        <LogoLink href={'https://minebase.com/'} target='_blank' rel='noreferrer'>
          <Logospan>
            <NonAuthLogo />
          </Logospan>
        </LogoLink>
        <NavItemsWrapper>
          {/* <SupportWrapper onClick={() => zE.activate()}>
            {t('nonAuthNavigation.items.help')}
          </SupportWrapper> */}
          <LanguagesDropdown />
          {isLoadingProfile ? (
            <LoadingCircle width='25px' thickness={5} isAbsolute={false} />
          ) : profile ? (
            <RightButton
              size='sm'
              nature='transparent'
              minWidth='110px'
              onClick={logout.mutate}
              text={t('nonAuthNavigation.items.logout')}
            />
          ) : registerMatch ? (
            <RightButton
              size='sm'
              nature='transparent'
              minWidth='110px'
              to={routes.login.path}
              text={t('nonAuthNavigation.items.login')}
            />
          ) : (
            <RightButton
              size='sm'
              nature='transparent'
              minWidth='110px'
              to={routes.register.path}
              text={t('nonAuthNavigation.items.register')}
            />
          )}
        </NavItemsWrapper>
      </Container>
    </Wrapper>
  )
}

export default NonAuthNavigation
